export default __webpack_public_path__ + "static/media/allyIcon.d790d717.png";